// Salary Upload Constants
export const SALARY_UPLOAD_REQUEST = 'SALARY_UPLOAD_REQUEST';
export const SALARY_UPLOAD_SUCCESS = 'SALARY_UPLOAD_SUCCESS';
export const SALARY_UPLOAD_FAIL = 'SALARY_UPLOAD_FAIL';
export const SALARY_UPLOAD_RESET = 'SALARY_UPLOAD_RESET';

// Create Salary Record
export const SALARY_CREATE_REQUEST = 'SALARY_CREATE_REQUEST';
export const SALARY_CREATE_SUCCESS = 'SALARY_CREATE_SUCCESS';
export const SALARY_CREATE_FAIL = 'SALARY_CREATE_FAIL';
export const SALARY_CREATE_RESET = 'SALARY_CREATE_RESET';

// Get All Salary Records
export const SALARY_LIST_REQUEST = 'SALARY_LIST_REQUEST';
export const SALARY_LIST_SUCCESS = 'SALARY_LIST_SUCCESS';
export const SALARY_LIST_FAIL = 'SALARY_LIST_FAIL';
export const SALARY_LIST_RESET = 'SALARY_LIST_RESET';

// Get Salary By ID
export const SALARY_DETAILS_REQUEST = 'SALARY_DETAILS_REQUEST';
export const SALARY_DETAILS_SUCCESS = 'SALARY_DETAILS_SUCCESS';
export const SALARY_DETAILS_FAIL = 'SALARY_DETAILS_FAIL';
export const SALARY_DETAILS_RESET = 'SALARY_DETAILS_RESET';

// Update Salary
export const SALARY_UPDATE_REQUEST = 'SALARY_UPDATE_REQUEST';
export const SALARY_UPDATE_SUCCESS = 'SALARY_UPDATE_SUCCESS';
export const SALARY_UPDATE_FAIL = 'SALARY_UPDATE_FAIL';
export const SALARY_UPDATE_RESET = 'SALARY_UPDATE_RESET';

// Delete Salary
export const SALARY_DELETE_REQUEST = 'SALARY_DELETE_REQUEST';
export const SALARY_DELETE_SUCCESS = 'SALARY_DELETE_SUCCESS';
export const SALARY_DELETE_FAIL = 'SALARY_DELETE_FAIL';
export const SALARY_DELETE_RESET = 'SALARY_DELETE_RESET';

// Bulk Delete Salary
export const SALARY_BULK_DELETE_REQUEST = 'SALARY_BULK_DELETE_REQUEST';
export const SALARY_BULK_DELETE_SUCCESS = 'SALARY_BULK_DELETE_SUCCESS';
export const SALARY_BULK_DELETE_FAIL = 'SALARY_BULK_DELETE_FAIL';
export const SALARY_BULK_DELETE_RESET = 'SALARY_BULK_DELETE_RESET';

// Get Salary Stats
export const SALARY_STATS_REQUEST = 'SALARY_STATS_REQUEST';
export const SALARY_STATS_SUCCESS = 'SALARY_STATS_SUCCESS';
export const SALARY_STATS_FAIL = 'SALARY_STATS_FAIL';
export const SALARY_STATS_RESET = 'SALARY_STATS_RESET';

// Approve Salary
export const SALARY_APPROVE_REQUEST = 'SALARY_APPROVE_REQUEST';
export const SALARY_APPROVE_SUCCESS = 'SALARY_APPROVE_SUCCESS';
export const SALARY_APPROVE_FAIL = 'SALARY_APPROVE_FAIL';
export const SALARY_APPROVE_RESET = 'SALARY_APPROVE_RESET';

// Approve All Salary
export const SALARY_APPROVE_ALL_REQUEST = 'SALARY_APPROVE_ALL_REQUEST';
export const SALARY_APPROVE_ALL_SUCCESS = 'SALARY_APPROVE_ALL_SUCCESS';
export const SALARY_APPROVE_ALL_FAIL = 'SALARY_APPROVE_ALL_FAIL';
export const SALARY_APPROVE_ALL_RESET = 'SALARY_APPROVE_ALL_RESET';

// Hold Salary
export const SALARY_HOLD_REQUEST = 'SALARY_HOLD_REQUEST';
export const SALARY_HOLD_SUCCESS = 'SALARY_HOLD_SUCCESS';
export const SALARY_HOLD_FAIL = 'SALARY_HOLD_FAIL';
export const SALARY_HOLD_RESET = 'SALARY_HOLD_RESET';

// Generate Salary from Employee Master
export const SALARY_GENERATE_REQUEST = 'SALARY_GENERATE_REQUEST';
export const SALARY_GENERATE_SUCCESS = 'SALARY_GENERATE_SUCCESS';
export const SALARY_GENERATE_FAIL = 'SALARY_GENERATE_FAIL';
export const SALARY_GENERATE_RESET = 'SALARY_GENERATE_RESET';
